<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">学校管理</span>
                <el-tabs v-model="activeTab" type="card">
                  <el-tab-pane name="1">
                    <span slot="label"> 学校列表 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <pagination v-loading="loading" :option="optionsForComponents.pagination"
                          :data="dataForComponents.pagination" @search="search" @add="add" @edit="edit"
                          @loadData="onLoadList"
                          @pageSizeChange="onPageSizeChange" @currentPageChange="onCurrentPageChange"></pagination>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane name="2">
                    <span slot="label"> 学校分组设置 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <universityGroupSetting :isReadonly="isReadonly"></universityGroupSetting>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="universityEditVisible" top="3vh">
      <university-edit :options="optionsForComponents.universityEdit" :data="dataForComponents.universityEdit"
        @closeDialog="onUniversityEditClose" @saveSuccess="onUniversityEditSaveSuccess"></university-edit>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.grid-content {
  /deep/ .el-table .cell {
    white-space: pre-line;
  }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import universityEdit from "../../components/universityManagement/universityEdit";
import universityGroupSetting from "../../components/universityManagement/universityGroupSetting";

import {
  getUniversityGroups,
  getUniversityPageData,
  getUniversityByGroup,
} from "../../service/common.service";

export default {
  data() {
    return {
      activeTab: "1",
      isReadonly: false,
      loading: false,
      universityEditVisible: false,
      pageCondition: {
        keyWord: null,
        pageSize: 20,
        pageNumber: 1,
      },
      optionsForComponents: {
        pagination: {
          displayPagination: true,
          hasEditButton: true,
          editButtonText: "编辑",
          hasAddButton: true,
          addButtonText: "添加",
          hasSearch: true,
        },
        universityEdit: {
          showTitle: true,
        },
      },
      dataForComponents: {
        pagination: [],
        universityEdit: {
          index: -1,
          item: null,
        },
      },
    };
  },
  components: {
    navigator,
    pagination,
    universityEdit,
    universityGroupSetting,
  },
  mounted() {
    this.loadUniversitiesFromServer();
  },
  methods: {
    async loadUniversitiesFromServer(pageCondition = this.pageCondition) {
      this.loading = true;

      let result = await getUniversityPageData(pageCondition);
      if (!!result && result.success) {
        this.dataForComponents.pagination = result.data;
      } else {
        this.dataForComponents.pagination = [];
      }

      this.loading = false;
    },
    search: function (keyword) {
      this.pageCondition.keyWord = keyword;
      //this.loadUniversitiesFromServer();
    },
    add: function () {
      let newData = {
        index: -1,
        item: null,
      };

      this.dataForComponents.universityEdit = newData;
      this.universityEditVisible = true;
    },
    edit: function (index, row) {
      let newData = {
        index: -1,
        item: null,
      };

      newData.index = index;
      newData.item = row;

      this.dataForComponents.universityEdit = newData;
      this.universityEditVisible = true;
    },
    onPageSizeChange(value) {
      this.pageCondition.pageSize = value;
    },
    onCurrentPageChange(value) {
      this.pageCondition.pageNumber = value;
    },
    onLoadList(pageData){
      this.loadUniversitiesFromServer(pageData);
    },
    onUniversityEditClose() {
      this.universityEditVisible = false;
    },
    onUniversityEditSaveSuccess(dataOut) {
      if (dataOut.needReload) {
        this.search(this.pageCondition.keyWord);
        return;
      }

      if (dataOut.index < 0) {
        this.dataForComponents.pagination.Results.unshift(dataOut.item);
        return;
      }

      let row = this.dataForComponents.pagination.Results[dataOut.index];
      if (!row) return;

      $.extend(true, row, dataOut.item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/admin/universityList.vue